<template>
  <div class="menu">
    <template v-for="childItem in list">
      <template v-if="childItem.children && childItem.children.length">
        <el-submenu
          :key="childItem.id"
          :index="childItem.path"
        >
          <template slot="title">
            <i :class="['iconfont', childItem.meta.icon, 'icon']"></i>
            <span slot="title">{{ childItem.meta.title }}</span>
          </template>
          <Slidbar :list="childItem.children" />
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item
          :key="childItem.id"
          :index="childItem.path"
          @click="toPage(childItem)"
        >
          <i
            v-if="childItem.meta.icon"
            :class="['iconfont', childItem.meta.icon, 'icon']"
          ></i>
          <i
            v-else
            class="icon-next"
          ></i>
          <span slot="title">{{ childItem.meta.title }}</span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: 'Slidbar',
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  methods: {
    toPage(item) {
      this.$router.push({
        path: item.path
      });
    }
  }
};
</script>
<style lang="less" scoped>
.menu {
  .el-menu-item {
    height: 38px !important;
    line-height: 38px !important;
    border-radius: 8px;
    margin: 4px 0;
    color: @title-color;
    i {
      color: #aaadb3;
      &.icon-next {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        border: 1px solid #aaadb3;
      }
    }
    span {
      margin-left: 10px;
    }
    &:hover,
    &:focus {
      background-color: @primary-color;
      color: #fff;
      i {
        color: #fff;
        &.icon-next {
          border: 1px solid @primary-color;
        }
      }
    }
    &.is-active {
      background-color: @primary-color;
      color: #fff;
      i {
        color: #fff;
        &.icon-next {
          border: 1px solid @primary-color;
        }
      }
    }
  }
  .el-submenu {
    :deep(.el-submenu__title) {
      height: 38px !important;
      line-height: 38px !important;
      border-radius: 8px;
      margin: 4px 0;
      color: @title-color;
      i {
        color: #aaadb3;
      }
      span {
        margin-left: 10px;
      }
      &:hover,
      &:focus {
        background-color: transparent;
      }
    }
    &.is-active {
      :deep(.el-submenu__title) {
        background: @primary-color;
        color: #fff;
        i {
          color: #fff;
        }
      }
    }
    :deep(.el-menu-item) {
      margin: 4px 0;
      &:hover,
      &:focus {
        background: none;
        color: @primary-color;
        i {
          color: @primary-color;
        }
      }
      &.is-active {
        background: none;
        color: @primary-color;
        i {
          color: @primary-color;
        }
      }
    }
  }
}
.el-menu--collapse .el-submenu {
  :deep(.el-submenu__title) {
    span {
      width: 0;
      height: 0;
      overflow: hidden;
      visibility: hidden;
      display: none;
    }
    .el-icon-arrow-right {
      display: none;
    }
  }
}
</style>
<style lang="less">
.el-menu--popup {
  border-radius: 8px !important;
  padding: 0 4px !important;
}
</style>
